<template>
  <div class="news-detail">
    <div class="defult_width">
      <div class="location">{{language === 'E' ? 'Location：' : '当前位置：'}}<router-link to="/IndustryNews">{{language === 'E' ? 'Industry News' : '行业新闻'}}</router-link> > <span>{{ detail.current.name }}</span></div>
      <!-- <div class="location">当前位置：<router-link to="/IndustryNews">行业新闻</router-link> > <span>{{ detail.current.name }}</span></div> -->
      <div class="left">
        <h5>{{ detail.current.name }}</h5>
        <div class="time">{{language === 'E' ? 'Release Time：' : '发布时间：'}}{{ detail.current.time.year + '/' + detail.current.time.month}}</div>
        <p v-if="$route.params.type">
          {{ detail.current.detail}}
        </p>
        <div v-else v-for="(item, key) in detail.current.html" :key="key">
          <img v-if="item.img" :src="item.img"  alt="">
          <p v-else-if="item.imgDetail" class="img-detail"> {{ item.imgDetail }} </p>
          <p class="p" v-else>
            {{ item }}
          </p>
        </div>
      </div>
      <div class="right">
        <!-- <div class="describe">
          <h5 class="right-title">
            TIPS
          </h5>
          <p>
            传播知识就是播种幸福，科学研究的进展及日益扩大的领域将唤起我们的希望，而存在于人类身心上的细菌也将逐渐消失。
          </p>
          <p>———— 诺贝尔</p>
        </div> -->
        <div class="list-box">
          <h5 class="right-title">{{language == 'E' ? 'Hot news' : '热门新闻'}}</h5>
          <ul>
            <li v-for="(item, key) in industry" :key="key">
              <router-link :to="`${item.id}`">
                <h5>
                  {{ item.name }}
                </h5>
                <p>
                  {{ (item.detail).substring(0, 60) + '...' }}
                </p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import news from '@/datas/news'
import Enews from '@/EnglishData/news'
export default {
  name: 'ProductCenter',
  data () {
    const language = localStorage.getItem('language')
    let languageNews = null
    if (language && language === 'E') {
      languageNews = Enews
    } else {
      languageNews = news
    }
    const { newsList, companyNewsList } = languageNews
    return {
      industry: [],
      detail: null,
      productIndex: 0,
      language,
      newsList,
      companyNewsList
    }
  },
  created () {
    let allList = this.$route.params.type ? this.companyNewsList : this.newsList
    let next = null; let pre = null
    let id = parseInt(this.$route.params.id)
    next = (id - 0) === 1 ? allList.length : (id - 0) - 1
    pre = (id - 0) === allList.length ? 1 : (id - 0) + 1
    let list = { current: null, preDetail: null, nextDetail: null }
    allList.forEach((item, index) => {
      if (index < 3) {
        this.industry.push(item)
      }
      if (item.id === id) {
        list.current = item
      }
      if (item.id === next) {
        list.nextDetail = item
      }
      if (item.id === pre) {
        list.preDetail = item
      }
    })
    this.detail = list
    console.log(this.industry)
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.news-detail {
  padding: 0 0 50px;
  border-top: 1px solid #e5e5e5;
  background: #f9f9f9;
  overflow: hidden;
  .location {
    padding: 20px 0;
    text-align: left;
    a {
      color: #333;
    }
  }
  .left {
    width: 65%;
    margin-right: 5%;
    float: left;
    text-align: center;
    h5 {
      font-size: 20px;
      color: 000;
      line-height: 40px;
      font-weight: 800;
    }
    .time {
      text-align: right;
      color: #888;
      margin: 10px 0 20px;
    }
    .p {
      text-align: left;
      line-height: 30px;
      text-indent: 2em;
      margin-bottom: 20px;
    }
    .img-detail {
      text-align: center;
      line-height: 20px;
      margin: -10px 0 30px;
    }
    img {
      margin: 0 auto;
      max-width: 100%;
      margin-bottom: 20px;
    }
  }
  .right {
    width: 30%;
    float: right;
    text-align: left;
    .describe {
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      p {
        margin-top: 20px;
        &:last-child {
          text-align: right;
        }
      }
    }
    .right-title {
      font-size: 18px;
      padding-bottom: 15px;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      &::after {
        position: absolute;
        content: ' ';
        display: block;
        left: 0;
        bottom: -2px;
        width: 45px;
        height: 4px;
        background: #1e50ae;
      }
    }
    .list-box {
      margin-top: 20px;
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      li {
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          h5 {
            font-size: 16px;
            line-height: 30px;
            color: #1e50ae;
          }
          p {
            font-size: 14px;
            line-height: 24px;
          }
        }
        &:last-child {
          a {
            border: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news/detail.vue